<div class="dashboard-wrapper">
  <app-breadcrumb
    [path]="'COMPONENT.SIDEBAR.dashboard' | translate"
    [station]="userName"
    [title]="'COMPONENT.SIDEBAR.dashboard' | translate"
  >
    <div class="flex justify-between items-center w-full">
      <div class="flex items-center">
        <!-- Reset Dashboard Button -->
        <div
          class="presentation-wrapper flex items-center border rounded-md py-1 px-3 cursor-pointer border-[var(--primary-color)] mr-3"
          (click)="resetDashboard()"
        >
          <div class="presentation-label mr-2">
            {{ 'DASHBOARD.reset_defaults' | translate }}
          </div>
          <mat-icon class="text-[var(--primary-color)]">refresh</mat-icon>
        </div>
      </div>
      <div
        class="presentation-wrapper flex items-center border rounded-md py-1 px-3 cursor-pointer border-[var(--primary-color)]"
        (click)="addItem()"
      >
        <div class="presentation-label mr-2">
          {{ 'DASHBOARD.add_widget' | translate }}
        </div>
        <div class="flex items-center">
          <mat-icon class="text-[var(--primary-color)]">add</mat-icon>
        </div>
      </div>
    </div>
  </app-breadcrumb>
  <div class="grid-container">
    <div class="grid-stack" #gridstack></div>
  </div>
</div>
